function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M5.99933 4.14882L1.99422 0.143779C1.90158 0.0510728 1.77792 0 1.64607 0C1.51422 0 1.39056 0.0510728 1.29793 0.143779L1.00298 0.438655C0.811055 0.6308 0.811055 0.94309 1.00298 1.13494L4.36617 4.49813L0.999248 7.86506C0.906615 7.95776 0.855469 8.08135 0.855469 8.21313C0.855469 8.34505 0.906615 8.46864 0.999248 8.56142L1.2942 8.85622C1.3869 8.94893 1.51049 9 1.64234 9C1.77419 9 1.89785 8.94893 1.99048 8.85622L5.99933 4.84752C6.09218 4.75452 6.14318 4.63035 6.14289 4.49835C6.14318 4.36584 6.09218 4.24175 5.99933 4.14882Z",
  fill: "#84CDBD"
});

var SvgMintrightarrow = function SvgMintrightarrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMintrightarrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mintrightarrow.7c3ca7be.svg";
export { ForwardRef as ReactComponent };